var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRockMusic = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Modern-Music-Bass-Guitar--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Modern Music Bass Guitar Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.22 8a0.25 0.25 0 0 0 -0.22 0.24v0.89a0.26 0.26 0 0 0 0.11 0.21l0.15 0.1a0.22 0.22 0 0 0 0.15 0.06h14.33a0.23 0.23 0 0 0 0.18 -0.08 0.25 0.25 0 0 0 0.06 -0.2A2.5 2.5 0 0 0 21.73 7a0.25 0.25 0 0 1 -0.23 -0.25V6a1 1 0 0 0 -2 0v0.75a0.25 0.25 0 0 1 -0.25 0.25h-1.5a0.25 0.25 0 0 1 -0.25 -0.25V6a1 1 0 0 0 -2 0v0.75a0.25 0.25 0 0 1 -0.25 0.25h-4.38a0.26 0.26 0 0 0 -0.21 0.11A2 2 0 0 1 9.22 8Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.08 11a0.24 0.24 0 0 0 -0.21 0.11 0.26 0.26 0 0 0 0 0.24l1.56 3.48a0.27 0.27 0 0 0 0.21 0.15 0.24 0.24 0 0 0 0.22 -0.1A4.5 4.5 0 1 1 15.5 22a4.17 4.17 0 0 1 -0.71 -0.06 0.28 0.28 0 0 0 -0.21 0.07 0.27 0.27 0 0 0 -0.08 0.19 3 3 0 0 1 -0.27 1.45 0.26 0.26 0 0 0 0 0.24 0.24 0.24 0 0 0 0.21 0.11h7A2.5 2.5 0 0 0 24 21.5V11.25a0.25 0.25 0 0 0 -0.25 -0.25Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 17.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0 -3 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.84 21.68 7.5 9.73v-3a0.25 0.25 0 0 1 0.25 -0.25h0.75A0.5 0.5 0 0 0 9 6V0.5a0.52 0.52 0 0 0 -0.24 -0.43 0.48 0.48 0 0 0 -0.48 0L5.38 1.5A2.49 2.49 0 0 0 4 3.74V6a0.5 0.5 0 0 0 0.5 0.5h0.75a0.25 0.25 0 0 1 0.25 0.25v9.5a0.75 0.75 0 0 1 -1.5 0v-2a0.24 0.24 0 0 0 -0.2 -0.24 0.24 0.24 0 0 0 -0.28 0.14L0.16 21.69a1.59 1.59 0 0 0 0.09 1.55 1.63 1.63 0 0 0 2 0.65l4.15 -1.8a0.23 0.23 0 0 1 0.2 0l4.16 1.79a1.61 1.61 0 0 0 2 -0.64 1.58 1.58 0 0 0 0.08 -1.56Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRockMusic);
export default ForwardRef;